import { Box, Chip, Link, styled, Typography } from '@material-ui/core';

export const SwaggerWrapper = styled(Box)(({ theme }) => ({
  '& .swagger-ui': {
    fontFamily: 'Open Sans, sans-serif',

    '& .auth-btn-wrapper': {
      justifyContent: 'center',
      gap: 16,
      marginTop: 20,
      '& .btn-done': {
        marginRight: 0,
      },
    },
    '& .scheme-container .schemes': {
      flexWrap: 'nowrap',
      gap: 24,
    },
    '& .schemes-server-container': {
      position: 'relative',
      border: `1px solid ${theme.palette.border}`,
      padding: '8px 16px',
      borderRadius: 3,
      width: '100%',
      '& > div': {
        width: '100%',
      },
      '& servers > label': {
        fontFamily: 'Open Sans, sans-serif',
        fontSize: 16,
        fontWeight: 400,
        color: theme.palette.text.primary,
        letterSpacing: '0.15px',
      },
      '& .servers-title': {
        position: 'absolute',
        top: '-8px',
        left: '16px',
        backgroundColor: theme.palette.common.white,
        padding: '0 8px',
        fontSize: 12,
        fontWeight: 400,
        letterSpacing: '0.4px',
        fontFamily: 'Open Sans, sans-serif',
        color: theme.palette.text.primary,
      },
      '& select': {
        fontWeight: 400,
        fontFamily: 'Open Sans, sans-serif',
        outline: 'none',
        border: 'none',
        boxShadow: 'none',
        backgroundColor: theme.palette.common.white,
      },
    },
    '& .scheme-container': {
      boxShadow: 'none',
      '& .auth-wrapper': {
        height: '44px',
      },
      '& .authorize': {
        alignItems: 'center',
        gap: 8,
        borderWidth: 1,
        '& span': {
          padding: 0,
          float: 'none',
        },
      },
    },
    '& .info li, & .info p, & .info table': {
      fontFamily: 'Open Sans, sans-serif',
      color: theme.palette.text.primary,
    },

    '& .info hgroup.main a': {
      fontSize: 14,
    },

    '& .main .link': {
      '& span': {
        display: 'none',
      },

      '&::after': {
        content: "'Download Specification'",
        position: 'absolute',
        color: theme.palette.primary.main,
        fontWeight: 700,
        fontSize: 16,
        lineHeight: '22px',
      },
      '&:hover::after': {
        textDecoration: 'underline',
      },
    },

    '& .info .link': {
      color: theme.palette.primary.main,
      fontFamily: 'Open Sans, sans-serif',
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '20px',
      textDecoration: 'none',
      position: 'relative',
      display: 'block',
      maxWidth: '180px',
      height: '22px',

      '&:hover': {
        textDecoration: 'underline',
      },
    },

    '& .opblock-tag': {
      fontFamily: 'Red Hat Display, sans-serif',
      borderColor: theme.palette.border,
      marginBottom: theme.spacing(2),

      '& small': {
        fontFamily: 'Open Sans, sans-serif',
      },
    },

    '& .opblock .opblock-summary-description': {
      fontFamily: 'Open Sans, sans-serif',
    },

    '& .info': {
      marginTop: 0,
    },

    '& .info .title': {
      fontFamily: 'Red Hat Display, sans-serif',
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      '& > span': {
        display: 'flex',
        gap: 12,
      },
      '& small': {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        padding: '2px 12px',
        border: `1px solid ${theme.palette.primary.main}`,
        position: 'static',
        marginLeft: 0,

        '&.version-stamp': {
          backgroundColor: theme.palette.common.white,

          '& pre': {
            color: theme.palette.primary.main,
          },
        },
      },
    },

    '& .btn.authorize': {
      color: theme.palette.success.main,
      borderColor: theme.palette.success.main,
    },
    '& .opblock .opblock-summary': {
      padding: '8px 16px',
    },
    '& .opblock.opblock-post': {
      border: '1px solid rgba(20, 86, 224, 0.2)',
      boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.1)',

      '& .opblock-summary-method': {
        backgroundColor: theme.palette.success.main,
      },
      '& .opblock-summary': {
        backgroundColor: '#F5F7FF',
      },
    },

    '& .opblock.opblock-get': {
      border: '1px solid rgba(20, 86, 224, 0.2)',
      boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.1)',

      '& .opblock-summary-method': {
        backgroundColor: theme.palette.primary.main,
      },
      '& .opblock-summary': {
        backgroundColor: '#F5F7FF',
      },
    },

    '& .opblock.opblock-put': {
      border: '1px solid rgba(20, 86, 224, 0.2)',
      boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.1)',

      '& .opblock-summary-method': {
        backgroundColor: theme.palette.warning.main,
      },
      '& .opblock-summary': {
        backgroundColor: '#F5F7FF',
      },
    },

    '& .opblock.opblock-delete': {
      border: '1px solid rgba(20, 86, 224, 0.2)',
      boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.1)',

      '& .opblock-summary-method': {
        backgroundColor: theme.palette.error.main,
      },
      '& .opblock-summary': {
        backgroundColor: '#F5F7FF',
      },
    },

    '& .opblock.opblock-patch': {
      border: '1px solid rgba(20, 86, 224, 0.2)',
      boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.1)',

      '& .opblock-summary-method': {
        backgroundColor: theme.palette.info.main,
      },
      '& .opblock-summary': {
        backgroundColor: '#F5F7FF',
      },
    },
  },
}));

export const DefinitionPageTitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Red Hat Display, sans-serif',
  fontSize: 34,
  fontWeight: 700,
  letterSpacing: '0.35px',
  lineHeight: '40px',
  color: theme.palette.text.primary,
}));

export const DefinitionPageTag = styled(Chip)(({ theme }) => ({
  fontFamily: 'Red Hat Display, sans-serif',
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: '0.15px',
  color: theme.palette.primary.main,
  backgroundColor: `${theme.palette.background.default} !important`,
  border: `1px solid ${theme.palette.primary.main}`,
}));

export const ClientCredentialsContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
});

export const ClientCredentialsLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 'inherit',
  textDecoration: 'underline',
  textDecorationThickness: 1,
  '&:hover': {
    textDecoration: 'none',
  },
}));
